import { NewChatIcon, planImg, ProIcon } from "images";
import { FaStar } from "react-icons/fa";
import classes from "./SingleCharacters.module.css";
import { Heading, Text } from "components/common";
import { useNavigate } from "react-router-dom";

import UpGradeToPro from "../UpGradeToPro/UpGradeToPro";
import { useState } from "react";
import { useAppContext } from "ContextProvider/ContextProvider";
import { generateRandomString } from "utils/generateRandomString";
const SingleCharacters = ({
  id,
  icon,
  name,
  info,
  rating,
  numberOfComment,
  is_pro,
}) => {
  const { myTheme } = useAppContext();
  const navigate = useNavigate();
  const [showUpgradeToProModal, setShowUpgradeToProModal] = useState(false);
  return (
    <>
      <div
        onClick={() => {
          let chatID = generateRandomString(25);
          navigate(`/chat/${chatID}/${id}`);
          // setShowUpgradeToProModal(true);
        }}
        className={classes.wrapper}
      >
        {is_pro && (
          <div className={classes.pro}>
            <span className={classes.proImg}>
              <ProIcon color={myTheme.color} />
            </span>
          </div>
        )}
        {icon && <img src={icon} alt={name} className={classes.img} />}
        <div className={classes.infoContainer}>
          <Heading primitive50 base medium>
            {name}
          </Heading>
          <Text sm primitive300>
            {info}
          </Text>
          <div className={classes.ratingAndComment}>
            {rating && (
              <Text className={classes.rating} sm primitive400>
                <FaStar className={classes.star} />
                {rating}
              </Text>
            )}
            {numberOfComment && (
              <Text className={classes.numberOfComment} sm primitive400>
                <span className={classes.chatIcon}>
                  <NewChatIcon color={myTheme.color} />
                </span>
                {numberOfComment}
              </Text>
            )}
          </div>
        </div>
      </div>
      {/* <UpGradeToPro
        id={id}
        isActive={showUpgradeToProModal}
        onClose={() => setShowUpgradeToProModal(false)}
        icon={icon}
        name={name}
        info={info}
        rating={rating}
        numberOfComment={numberOfComment}
      /> */}
    </>
  );
};
export default SingleCharacters;
